<div class="unauthorized-container">
  <mat-card class="unauthorized-card">
    <mat-card-header>
      <mat-icon class="warning-icon">lock</mat-icon>
    </mat-card-header>
    <mat-card-content>
      <h1 class="title">{{'common.unauthorized' | translate}}</h1>
      <p class="message">{{'common.unauthorized_text' | translate}}</p>
      <p class="sub-message">{{'common.unauthorized_sub_text' | translate}}</p>
    </mat-card-content>
    <mat-card-actions>
      <button mat-raised-button color="primary" (click)="requestAccess()">
        {{'common.request_access' | translate}}
      </button>
    </mat-card-actions>
  </mat-card>
</div>